export const companyLinks = [
  { text: "The Linkit Blog", href: "#" },
  { text: "Engineering Blog", href: "#" },
  { text: "Marketplace", href: "#" },
  { text: "What's New", href: "#" },
  { text: "About", href: "#" },
  { text: "Press", href: "#" },
  { text: "Careers", href: "#" },
  { text: "Social Good", href: "#" },
  { text: "Contact", href: "#" }
];

export const communityLinks = [
  { text: "Linkit Creator Services Program", href: "#" },
  { text: "Linkit for Enterprise", href: "#" },
  { text: "2022 Creator Report", href: "#" },
  { text: "Charities", href: "#" },
  { text: "Creator Profile Directory", href: "#" },
  { text: "Explore Templates", href: "#" }
];

export const supportLinks = [
  { text: "Help Topics", href: "#" },
  { text: "Getting Started", href: "#" },
  { text: "Linkit Pro", href: "#" },
  { text: "Features & How-Tos", href: "#" },
  { text: "FAQs", href: "#" },
  { text: "Report a Violation", href: "#" }
];

export const legalLinks = [
  { text: "Terms & Conditions", href: "#" },
  { text: "Privacy Notice", href: "#" },
  { text: "Cookie Notice", href: "#" },
  { text: "Trust Center", href: "#" }
];